// angle up

export const chevronUp = `<svg aria-hidden="true" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 32">
<path d="M11.063 9.981l8.5 8.5c0.588 0.587 0.588 1.537 0 2.119l-1.412 1.413c-0.588 0.587-1.538 0.587-2.119 0l-6.031-6.019-6.025 6.025c-0.587 0.588-1.537 0.588-2.119 0l-1.419-1.412c-0.588-0.588-0.588-1.538 0-2.119l8.5-8.5c0.588-0.594 1.537-0.594 2.125-0.006z"></path>
</svg>`;
